export default __webpack_public_path__ + "static/media/d902ab7b5c9a12953a0a5f802971a933.svg";